import { isFeatureEnabled } from 'owa-feature-flags';
import { OfficeApp } from './store/schema/OfficeApp';

export default function isSupportedOfficeRailApp(app: OfficeApp) {
    return isFeatureEnabled('tri-officeRailHost') && app === 'Yammer';
}
